// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#friends-page menu.friends-page__menu {
    list-style-type: none;
}

#friends-page menu.friends-page__menu li {
    font-size: 18px;
}
#friends-page menu.friends-page__menu li:hover {
    background-color: var(--primary-color-light);
    border-radius: 10px;
}
#friends-page menu.friends-page__menu svg {
    width: 22px;
    margin-right: 5px;
    margin-bottom: -5px;
    color: var(--icon-color);
}
#friends-page menu.friends-page__menu a:link,
#friends-page menu.friends-page__menu a:visited,
#friends-page menu.friends-page__menu a:active {
    display: block;
    padding: 10px;
    color: var(--primary-color-darkest);
}
#friends-page menu.friends-page__menu a.active  {
    font-weight: bold;
}

#friends-page menu.friends-page__menu .outline { 
    display: inline-block;
}
#friends-page menu.friends-page__menu .active .outline { 
    display: none;
}

#friends-page menu.friends-page__menu .solid {
    display: none;
}
#friends-page menu.friends-page__menu .active .solid{
    display: inline-block;
}


@media (width >= 750px) {
    #friends-page .content {
        padding: 30px;
    }
}
@media (width < 750px) {
    #friends-page .content {
        padding: 10px;
        box-sizing: border-box;
    }

    #friends-page menu.friends-page__menu {
        text-align: center;
    }

    #friends-page menu.friends-page__menu li {
        display: inline-block;
    }
    
    #friends-page menu.friends-page__menu li .nav-text {
        display: block;
        font-size: 10px;
    }
}
`, "",{"version":3,"sources":["webpack://./client/pages/friends/FriendsPage.css"],"names":[],"mappings":"AAAA;IACI,qBAAqB;AACzB;;AAEA;IACI,eAAe;AACnB;AACA;IACI,4CAA4C;IAC5C,mBAAmB;AACvB;AACA;IACI,WAAW;IACX,iBAAiB;IACjB,mBAAmB;IACnB,wBAAwB;AAC5B;AACA;;;IAGI,cAAc;IACd,aAAa;IACb,mCAAmC;AACvC;AACA;IACI,iBAAiB;AACrB;;AAEA;IACI,qBAAqB;AACzB;AACA;IACI,aAAa;AACjB;;AAEA;IACI,aAAa;AACjB;AACA;IACI,qBAAqB;AACzB;;;AAGA;IACI;QACI,aAAa;IACjB;AACJ;AACA;IACI;QACI,aAAa;QACb,sBAAsB;IAC1B;;IAEA;QACI,kBAAkB;IACtB;;IAEA;QACI,qBAAqB;IACzB;;IAEA;QACI,cAAc;QACd,eAAe;IACnB;AACJ","sourcesContent":["#friends-page menu.friends-page__menu {\n    list-style-type: none;\n}\n\n#friends-page menu.friends-page__menu li {\n    font-size: 18px;\n}\n#friends-page menu.friends-page__menu li:hover {\n    background-color: var(--primary-color-light);\n    border-radius: 10px;\n}\n#friends-page menu.friends-page__menu svg {\n    width: 22px;\n    margin-right: 5px;\n    margin-bottom: -5px;\n    color: var(--icon-color);\n}\n#friends-page menu.friends-page__menu a:link,\n#friends-page menu.friends-page__menu a:visited,\n#friends-page menu.friends-page__menu a:active {\n    display: block;\n    padding: 10px;\n    color: var(--primary-color-darkest);\n}\n#friends-page menu.friends-page__menu a.active  {\n    font-weight: bold;\n}\n\n#friends-page menu.friends-page__menu .outline { \n    display: inline-block;\n}\n#friends-page menu.friends-page__menu .active .outline { \n    display: none;\n}\n\n#friends-page menu.friends-page__menu .solid {\n    display: none;\n}\n#friends-page menu.friends-page__menu .active .solid{\n    display: inline-block;\n}\n\n\n@media (width >= 750px) {\n    #friends-page .content {\n        padding: 30px;\n    }\n}\n@media (width < 750px) {\n    #friends-page .content {\n        padding: 10px;\n        box-sizing: border-box;\n    }\n\n    #friends-page menu.friends-page__menu {\n        text-align: center;\n    }\n\n    #friends-page menu.friends-page__menu li {\n        display: inline-block;\n    }\n    \n    #friends-page menu.friends-page__menu li .nav-text {\n        display: block;\n        font-size: 10px;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
